import { getTypedState } from 'ducks/hooks'
import { PropertyContact } from 'ducks/types'

export const getPropertyContacts = () => (): PropertyContact[] => {
  const { propertyContacts } = getTypedState()
  return propertyContacts
}
